import { StyledSingleSelectDDItem } from "app/pages/sales-intelligence/common-components/dropdown/styles";
import styled from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes } from "@similarweb/styles";

export const StyledDetailedItem = styled(StyledSingleSelectDDItem)`
    flex-direction: column;
    align-items: flex-start;
    row-gap: 6px;
    height: auto;

    padding-top: 16px;
    padding-bottom: 16px;
`;

export const StyledItemTitleWrapper = styled(FlexRow)`
    align-items: center;
`;

export const StyledDropdownItemsDivider = styled.div`
    position: relative;
    height: 24px;

    &:after {
        content: "";
        position: absolute;
        top: 12px;
        left: 10px;
        width: calc(100% - 20px);
        border-bottom: 1px ${colorsPalettes.carbon["100"]} solid;
    }
`;
